import styles from "./driverJobDelivery.module.css";
import dayjs from "dayjs";
import { forwardRef } from "react";

export const ComponentToPrint = forwardRef((props, ref) => {

  return (<div ref={ref} style={{ padding: "50px" }}>
    <div className={`${styles.PrintClass1}`}>
      <h4>{props?.driver?.name}</h4>
      <h3>{dayjs(props?.delivery_driver?.updated_at).format("dddd, D MMM YYYY")}</h3>
    </div>

    <div className={`${styles.PrintClass2}`}>
      <div className={`${styles.PrintClass3}`}>SL No.<br />1</div>
      <div className={`${styles.PrintClass4}`}>
        <h4>Booking Ref.</h4>
        <p>{props?.bookingData?.reference_id}</p>
        <br />
        <h4>Total</h4>
        <p>£{parseFloat(props?.bookingData?.total).toFixed(2)}</p>
      </div>
      <div className={`${styles.PrintClass5}`}>
        <h4>{props?.bookingData?.recipient_details?.name}</h4>
        <p>{props?.bookingData?.recipient_details?.phone}</p>
        <br />
        <h5>Delivery Details</h5>
        <p>{props?.bookingData?.recipient_details?.address}</p>
      </div>
    </div>

    <div className={`${styles.PrintClass9}`}>
      <h4>Delivery Note.</h4>
      <p>{props?.delivery_note}</p>
    </div>
  </div>);
});